import { render, staticRenderFns } from "./CoursewareAccordionContainer.vue?vue&type=template&id=11a35d9e&"
import script from "./CoursewareAccordionContainer.vue?vue&type=script&lang=js&"
export * from "./CoursewareAccordionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports